"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Snackbar = void 0;
var _contexts = require("../../contexts");
const Snackbar = () => {
  const {
    snackbar
  } = (0, _contexts.useResultDialog)();
  return snackbar;
};
exports.Snackbar = Snackbar;
